import { render, staticRenderFns } from "./VerticalIconMessage.vue?vue&type=template&id=056e56f2&"
import script from "./VerticalIconMessage.vue?vue&type=script&lang=js&"
export * from "./VerticalIconMessage.vue?vue&type=script&lang=js&"
import style0 from "./VerticalIconMessage.vue?vue&type=style&index=0&id=056e56f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports